import afterFrame from 'afterframe';

export default function afterFrameIfAvailable(
  callback: (time: number) => void
): void {
  if (typeof requestAnimationFrame !== 'function') {
    console.warn(
      'requestAnimationFrame is not available, afterFrame timings will not be reported'
    );
    return;
  }
  afterFrame(callback);
}
